import { ASSETS } from "@/lib/api";
import { useSettings } from "@/contexts/SettingsContext";
import { Instagram, Facebook, MapPin, Phone } from "lucide-react";

export default function MaintenancePage() {
  const { address, phone } = useSettings();

  return (
    <div
      data-testid="maintenance-page"
      className="min-h-screen flex flex-col items-center justify-center px-6 py-16 bg-[var(--trio-bg)] text-center"
    >
      <img src={ASSETS.logo} alt="Trio" className="h-16 w-auto mb-10" />

      <div className="text-[11px] tracking-[0.3em] uppercase text-[var(--trio-primary)] font-bold mb-4">
        Something Big is Coming
      </div>

      <h1 className="font-display uppercase text-5xl sm:text-6xl lg:text-7xl tracking-tight leading-[0.9] max-w-3xl">
        We&apos;re polishing<br />
        <span className="text-[var(--trio-primary)]">the room.</span>
      </h1>

      <p className="mt-8 max-w-lg text-base sm:text-lg leading-relaxed text-[var(--trio-muted)]">
        Trio is putting the finishing touches on our new home online.
        Come back soon — until then, we&apos;re still slinging plates in person.
      </p>

      <div className="mt-12 space-y-3 text-sm text-[var(--trio-muted)]">
        <div className="flex items-center justify-center gap-2">
          <MapPin className="w-4 h-4 text-[var(--trio-primary)]" />
          <span>{address}</span>
        </div>
        <div className="flex items-center justify-center gap-2">
          <Phone className="w-4 h-4 text-[var(--trio-primary)]" />
          <a href={`tel:${phone}`} className="hover:text-[var(--trio-primary)]">
            {phone}
          </a>
        </div>
      </div>

      <div className="mt-10 flex items-center gap-3">
        <a
          href="https://www.instagram.com/triohsv/"
          target="_blank"
          rel="noreferrer"
          aria-label="Instagram"
          className="w-11 h-11 border border-[var(--trio-text)] hover:border-[var(--trio-accent)] hover:text-[var(--trio-accent)] flex items-center justify-center transition-colors"
        >
          <Instagram className="w-4 h-4" />
        </a>
        <a
          href="https://www.facebook.com/share/17jHJeBudX/?mibextid=wwXIfr"
          target="_blank"
          rel="noreferrer"
          aria-label="Facebook"
          className="w-11 h-11 border border-[var(--trio-text)] hover:border-[var(--trio-accent)] hover:text-[var(--trio-accent)] flex items-center justify-center transition-colors"
        >
          <Facebook className="w-4 h-4" />
        </a>
      </div>

      <div className="mt-16 text-[10px] tracking-[0.3em] uppercase text-[var(--trio-muted)]">
        Eat. Drink. Vibe.
      </div>
    </div>
  );
}
